import { render } from "./BasicInfoCard.vue?vue&type=template&id=ec74ac5c&scoped=true"
import script from "./BasicInfoCard.vue?vue&type=script&lang=js"
export * from "./BasicInfoCard.vue?vue&type=script&lang=js"

import "./BasicInfoCard.vue?vue&type=style&index=0&id=ec74ac5c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec74ac5c"]])

export default __exports__